module.exports = __webpack_public_path__ + "assets/img/guide.7546343b.jpg";